/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function() {
        // JavaScript to be fired on all pages
        //   if ($(window).width() > 801) {
        //     $(window).bind('scroll', function () {
        //       if ($(window).scrollTop() > 85) {
        //           $('.stickymenu').addClass('fixed');
        //       } else {
        //           $('.stickymenu').removeClass('fixed');
        //       }
        //   });
        // }

        WebFont.load({
          google: {
            families: ["Open Sans","Lekton:400italic"]
          }
        });

        $(".mobile-toggle").on("click", function(e) {
          e.preventDefault();
          $(".stickymenu .navbar").slideToggle();
        });

        var touchmoved;

        var tapped = false;
        $(".menu-item-has-children > a")
          .on("touchend", function(e) {
            if (touchmoved !== true) {
              // you're on button click action

              var sub_menu = $(this)
                .parent()
                .find(".sub-menu");

              if (!tapped) {
                //if tap is not set, set up single tap
                e.preventDefault();

                tapped = setTimeout(function() {
                  tapped = null;
                  if (sub_menu.is(":visible")) {
                    sub_menu.css({ display: "none" });
                  } else {
                    $(".sub-menu").css({ display: "none" });
                    sub_menu.css({ display: "flex" });
                  }
                }, 300); //wait 300ms then run single click code
              } else {
                //tapped within 300ms of last tap. double tap
                clearTimeout(tapped); //stop single tap callback
                tapped = null;
                sub_menu.css({ display: "none" });
              }
            }
          })
          .on("touchmove", function(e) {
            touchmoved = true;
          })
          .on("touchstart", function() {
            touchmoved = false;
          });

          // var interTimer;
          // interTimer = setInterval(function(){
          //   var imgPreview = document.querySelector('#nbdesigner_frontend_area img');
          //   console.log(imgPreview, "imgPreview");
          
          //   // /srv/www/mijnreclamevlag.nl/releases/20220127141008/web/app/uploads/nbdesigner/designs/ce310421644421846/preview/frame_0.png?t=1644421846958
          //   if(imgPreview) {
          //     var src = imgPreview.getAttribute('src');
          //     if (src.includes('www/mijnreclamevlag.nl/releases')) {
          //       var splitSrc = src.split('/web/app/');
          //       src = '/app/' + splitSrc[1];
          //       imgPreview.setAttribute('src',src);
          //       console.log('Source', src);
          //       clearInterval(interTimer);
          //     }
          //   }
          // },1000);
          if(document.getElementById("triggerDesign")){
          document.getElementById("triggerDesign").onclick = function(){
          var interTimer;
          interTimer = setInterval(function(){
            var imgPreviews = document.querySelectorAll('#nbdesigner_frontend_area img');
            
            // /srv/www/mijnreclamevlag.nl/releases/20220127141008/web/app/uploads/nbdesigner/designs/ce310421644421846/preview/frame_0.png?t=1644421846958
            if(imgPreviews) {
              imgPreviews.forEach(function(imgPreview){
                var src = imgPreview.getAttribute('src');
                var splitSrc;
                // DEMO: /home/web/webapps/mijnreclamevlag/releases/1675774199155/web/app/uploads/nbdesigner/designs/fc9d3101687182188/preview/frame_0.png?t=1687182188051
                if (src.includes('home/web/webapps/mijnreclamevlag/releases')) {
                  splitSrc = src.split('/web/app/');
                  src = '/app/' + splitSrc[1];
                  imgPreview.setAttribute('src',src);
                  clearInterval(interTimer);
                } else if (src.includes('/app/web/app/')) {
                  splitSrc = src.split('/web/app/');
                  src = '/app/' + splitSrc[1];
                  imgPreview.setAttribute('src',src);
                  clearInterval(interTimer);
                }
              });
            }
          },1000);
        };
      }
      },//end init common
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $(".dropdown-menu a.dropdown-toggle").on("click", function(e) {
          e.preventDefault();
          if (
            !$(this)
              .next()
              .hasClass("show")
          ) {
            $(this)
              .parents(".dropdown-menu")
              .first()
              .find(".show")
              .removeClass("show");
          }
          var $subMenu = $(this).parent(".dropdown");
          $subMenu.toggleClass("show");

          $(this)
            .parents("li.nav-item.dropdown.show")
            .on("hidden.bs.dropdown", function(e) {
              $(".dropdown-submenu .show").removeClass("show");
            });

          return false;
        });

        // if ($('.checkout-subscribe-action input').length ) {
        //   console.log('yesss');
        //   $('.checkout-subscribe-action input').attr('disabled','disabled');
        //   $('.checkout-subscribe-action input').prop('checked', false);
        //    $('.checkout-subscribe-action input').prop('disabled', true);
        // }
        
      }
    },
    // Home page
    home: {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // FAQ page
    faq: {
      init: function() {
        // $('.antwoord').hide();

        var hash = window.location.hash;
        // console.log(hash);
        $(hash).show();
        $('a[href="' + hash + '"]')
          .find("i")
          .toggleClass("fa-plus")
          .toggleClass("fa-minus");

        $(".vraag").on("click", function(e) {
          e.preventDefault();
          var link = $(this).attr("href");
          $(link).slideToggle();
          $(this)
            .find("i")
            .toggleClass("fa-plus")
            .toggleClass("fa-minus");
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function(
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
